/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_LinkInputs */

const en_add_link = /** @type {(inputs: Add_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Link`)
};

const id_add_link = /** @type {(inputs: Add_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah Tautan`)
};

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const es_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const fr_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const de_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const ja_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const zh_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const ar_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const it_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const ru_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const pt_add_link = en_add_link;

/** @type {(inputs: Add_LinkInputs) => LocalizedString} */
const ko_add_link = en_add_link;

/**
* | output |
* | --- |
* | "Add Link" |
*
* @param {Add_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_link = /** @type {((inputs?: Add_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_link(inputs)
	if (locale === "es") return es_add_link(inputs)
	if (locale === "fr") return fr_add_link(inputs)
	if (locale === "de") return de_add_link(inputs)
	if (locale === "ja") return ja_add_link(inputs)
	if (locale === "zh") return zh_add_link(inputs)
	if (locale === "ar") return ar_add_link(inputs)
	if (locale === "id") return id_add_link(inputs)
	if (locale === "it") return it_add_link(inputs)
	if (locale === "ru") return ru_add_link(inputs)
	if (locale === "pt") return pt_add_link(inputs)
	return ko_add_link(inputs)
});